import { useContext } from 'react';
import ProductContext from '../context/Product/Context';
import totalPriceCarts from './totalCarts';
import useProductDataByCountry from './useProductDataByCountry';

/**
 * Return data to Atrato pays
 *
 * @returns {object} data Atrato
 */
function useDataAtrato() {
  const productContext = useContext(ProductContext);
  const { carts, products } = productContext;
  const totalPrice = totalPriceCarts(carts, false).toString();
  const productsData = useProductDataByCountry(products, false);

  const getProducts = () => {
    let nameProducts = '';

    productsData.forEach((prod, index) => {
      nameProducts = `${nameProducts}${(productsData.length === 0 || productsData.length === index || nameProducts === '') ? '' : ', '}${prod.name}`;
    });

    return nameProducts;
  };

  return {
    paymentWay: 'Atrato método de pago',
    orderNumber: carts[0].id,
    orderId: carts[0].id,
    price: totalPrice,
    product: getProducts(),
    email: carts[0].customerEmail,
    name: 'John',
    phone: '5530018304',
    idCommerce: process.env.REACT_APP_ID_COMMERCE_ATRATO,
    platform: 'Moons',
    type: 'pago',
    host: 'https://atratopago.com',
  };
}

export default useDataAtrato;
